module.exports = __webpack_public_path__ + "img/icon-saving-line.2302d34d.svg";